<template>
  <CardPrimary :style="style.card">
    <template v-if="isLoading">
      <LoaderPrimary />
    </template>
    <template v-else>
      <div :style="style.chartOptionsContainer">
        <TagOptionPrimary
          :selected="!isShowingRequiredSkills"
          @click="switchChartOption"
          :style="style.tagOption"
        >
          All skills
        </TagOptionPrimary>
        <TagOptionPrimary
          :selected="isShowingRequiredSkills"
          @click="switchChartOption"
          :style="style.tagOption"
        >
          Required skills
        </TagOptionPrimary>
      </div>
      <template v-if="isShowingRequiredSkills">
        <PieChartPrimary
          v-if="requiredSkillsDependencyData.length > 0"
          :data="requiredSkillsDependencyData"
          :labels="requiredSkillsDependencyLabels"
        />
        <NoDataToShow
          v-else-if="requiredSkillNotRegistered"
          :textBottom="true"
        >
          No required skill is registered yet.
        </NoDataToShow>
        <NoDataToShow
          v-else
          :textBottom="true"
        >
          No shown member has the required skills.
        </NoDataToShow>
      </template>
      <template v-else>
        <PieChartPrimary
          v-if="skillsDependencyData.length > 0"
          :data="skillsDependencyData"
          :labels="skillsDependencyLabels"
        />
        <NoDataToShow
          v-else
          :textBottom="true"
        >
          Add members and choose skills to show.
        </NoDataToShow>
      </template>
    </template>
  </CardPrimary>
</template>

<script>
  import CardPrimary from '@modules/card/card-primary'
  import LoaderPrimary from '@modules/loader/loader-primary'
  import NoDataToShow from '@modules/error/no-data-to-show'
  import PieChartPrimary from '@modules/chart/pie-chart-primary'
  import TagOptionPrimary from '@modules/tag/tag-option-primary'
  import { Layout } from '@js/styles'

  export default {
    name: 'SkillsDependency',
    components: {
      CardPrimary,
      LoaderPrimary,
      NoDataToShow,
      PieChartPrimary,
      TagOptionPrimary,
    },
    props: {
      isLoading: {
        type: Boolean,
        required: false,
        default: false,
      },
      requiredSkills: {
        type: Array,
        required: false,
        default: () => [],
      },
      skillNodes: {
        type: Array,
        required: false,
        default: () => [],
      },
      tenantUsers: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data: function () {
      return {
        isShowingRequiredSkills: false,
        style: {
          card: {
            height: '100%',
            padding: '60px 0',
            position: 'relative',
          },
          chartOptionsContainer: {
            left: 0,
            padding: `${Layout.space.md} 0 0 ${Layout.space.sm}`,
            position: 'absolute',
            top: 0,
          },
          tagOption: {
            margin: `0 0 0 ${Layout.space.sm}`,
          },
        },
      };
    },
    computed: {
      requiredSkillNotRegistered: function () {
        return this.requiredSkills.length === 0;
      },
      requiredSkillsDependencyData: function () {
        return this.getTenantUserSkillCount(this.skillNodes.filter(elem => elem.required)).map(elem => elem.count);
      },
      requiredSkillsDependencyLabels: function () {
        return this.getTenantUserSkillCount(this.skillNodes.filter(elem => elem.required)).map(elem => elem.userName);
      },
      skillsDependencyData: function () {
        return this.getTenantUserSkillCount(this.skillNodes).map(elem => elem.count);
      },
      skillsDependencyLabels: function () {
        return this.getTenantUserSkillCount(this.skillNodes).map(elem => elem.userName);
      },
    },
    methods: {
      getTenantUserSkillCount: function (skillNodes) {
        const tenantUserSkillCount = {};
        const tenantUsers = {};

        skillNodes.forEach(elem => {
          const skillOwners = elem.tenantUsers;
          elem.tenantUsers.forEach(e => {
            if (e.id in tenantUserSkillCount) {
              tenantUserSkillCount[e.id]++;
            } else {
              tenantUserSkillCount[e.id] = 1;
              tenantUsers[e.id] = { ...e };
            }
          });
        });

        return Object.entries(tenantUserSkillCount).sort(
          ([,count1], [,count2]) => count2 - count1).reduce((result, elem) => {
            const tenantUserId = elem[0];
            const count = elem[1];
            const user = tenantUsers[tenantUserId].user;
            const userName = `${user.firstName} ${user.lastName}`;
            result.push({
              userName: userName,
              count: elem[1]
            });
            return result;
          }, []);
      },
      switchChartOption: function () {
        this.isShowingRequiredSkills = !this.isShowingRequiredSkills;
      },
    },
  };
</script>
